module.exports = __webpack_public_path__ + "static/media/Watermelon_thumb.cf49ae87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/weird-wonderful/Watermelon_thumb.png
// module id = 372
// module chunks = 0